import React from 'react';

import classNames from 'classnames';

import {useFeature} from 'components/feature';

import {STEPS} from '../../constants/checkout';

import AuthHelper from '../authHelper/authHelper';
import {DigicertIconTooltip} from '../digicertIconTooltip/digicertIconTooltip';

import s from './stepTitle.scss';

type PropsType = {
    step: STEPS;
    currentStep: STEPS;
    resumeComponent?: React.ReactElement;
    children?: React.ReactNode;
};

type StepsInformationType = {
    [key: string]: {number: number; icon: React.ReactElement; authorization?: React.ReactElement};
};

const STEPS_INFORMATION: StepsInformationType = {
    [STEPS.DELIVERY_STEP]: {
        authorization: <AuthHelper />,
        icon: <DigicertIconTooltip />,
        number: 1,
    },
    [STEPS.PAYMENT_STEP]: {
        icon: <DigicertIconTooltip />,
        number: 2,
    },
};

/**
 * Step title for checkout
 *
 * @constructor
 */
export const StepTitle: React.FC<PropsType> = ({children, currentStep, resumeComponent, step}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    const {authorization, icon, number} = STEPS_INFORMATION[step];

    const isPaymentStep = currentStep === STEPS.PAYMENT_STEP;

    if (step !== currentStep && resumeComponent) {
        return resumeComponent;
    }

    return (
        <div
            className={classNames(s.wrapper, {
                [s.active]: step === currentStep,
                [s.paymentStep]: isPaymentStep,
                [s.paymentStepFacelift]: isFacelift && isPaymentStep,
                [s.withAuthorization]: authorization,
                [s.wrapperFacelift]: isFacelift,
            })}
        >
            <div className={s.wrapTitle}>
                <div className={s.title}>
                    <div className={s.number}>{number}</div>
                    <div className={s.content}>{children}</div>
                </div>
                {authorization && (
                    <div aria-label="Login information" className={s.authorization}>
                        {authorization}
                    </div>
                )}
            </div>
            <div className={classNames(s.icon, s.digicertIcon)}>{icon}</div>
        </div>
    );
};
